
function LoadingSpinner() {
    return (
        <div className="spinner-container">
            <div className="loading-spinner" />
        </div>
    );
}

export default LoadingSpinner;